// src/services/propostaService.js
import api from '../services/api';

export const listarPropostas = async () => {
    try {
        const response = await api.get('/propostas');
        console.log('Resposta do serviço de propostas:', response); // Debug
        return response;
    } catch (error) {
        console.error('Erro no serviço de propostas:', error);
        throw error;
    }
};

export const obterProposta = async (id) => {
    try {
        const response = await api.get(`/propostas/${id}`);
        console.log('Resposta da API:', response); // Debug
        return response.data;
    } catch (error) {
        console.error('Erro ao obter proposta:', error.response?.data || error);
        throw error;
    }
};

export const criarProposta = async (proposta) => {
    try {
        console.log('Dados sendo enviados para criar proposta:', proposta); // Log dos dados enviados
        const response = await api.post('/propostas', proposta);
        console.log('Resposta do servidor:', response.data); // Log da resposta
        return response.data;
    } catch (error) {
        console.error('Erro ao criar proposta:', {
            status: error.response?.status,
            data: error.response?.data,
            mensagem: error.response?.data?.message || error.message
        });
        throw error;
    }
};

export const atualizarProposta = async (id, proposta) => {
    try {
        const response = await api.put(`/propostas/${id}`, proposta);
        return response.data;
    } catch (error) {
        console.error('Erro ao atualizar proposta:', error.response?.data || error);
        throw error;
    }
};

export const excluirProposta = async (id) => {
    try {
        const response = await api.delete(`/propostas/${id}`);
        return response.data;
    } catch (error) {
        console.error('Erro ao excluir proposta:', error.response?.data || error);
        throw error;
    }
};

export const aprovarProposta = async (id, observacoes = '') => {
    try {
      // Garantir que observacoes nunca será undefined no objeto
      const obsSegura = observacoes !== undefined ? observacoes : '';
      
      const response = await api.post(`/propostas/${id}/aprovar`, {
        observacoes: obsSegura
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao aprovar proposta:', error.response?.data || error);
      throw error;
    }
  };
// propostaService.js
export const obterSimilaridade = async (id) => {
    try {
      const response = await api.get(`/propostas/${id}/similaridade`);
      console.log('Dados brutos de similaridade recebidos:', response.data);
  
      // Se quiser converter certos campos em número, ou apenas passar tudo adiante, 
      // faça um mapeamento que preserve 'propostaOriginal':
      const dadosBrutos = response.data;
      const dadosFormatados = dadosBrutos.map(item => ({
        // Mantenha o ID da proposta similar
        propostaId: item.propostaId,
  
        // Caso deseje, converta a similaridade em float ou mantenha como está:
        similaridade: parseFloat(item.similaridade || 0),
        
        // Se você tiver "simDireto", "jaroWinkler", "tfIdf" ou algo similar, 
        // também pode convertê-los aqui:
        // similaridadeDireta: parseFloat(item.similaridadeDireta || 0),
        // jaroWinkler: parseFloat(item.jaroWinkler || 0),
  
        mensagem: item.mensagem,
  
        // Se 'termosComuns' vier em outro campo, preserve como array ou string.
        // Ajuste conforme seu back-end:
        termosComuns: item.termosComuns || [],
  
        // A parte CRUCIAL: manter intacto o objeto 'propostaOriginal'
        // para que o front possa acessar proposalOriginal.titulo, etc.
        propostaOriginal: {
          titulo: item.propostaOriginal?.titulo,
          problemaPesquisa: item.propostaOriginal?.problemaPesquisa,
          estudante: item.propostaOriginal?.estudante,
          dataSubmissao: item.propostaOriginal?.dataSubmissao
        }
      }));
  
      console.log('Dados formatados para uso no front:', dadosFormatados);
      return dadosFormatados;
  
    } catch (error) {
      console.error('Erro ao obter similaridade:', error);
      throw error;
    }
  };
  
export const rejeitarProposta = async (id, motivoRejeicao) => {
    try {
        const response = await api.post(`/propostas/${id}/rejeitar`, { motivoRejeicao });
        return response.data;
    } catch (error) {
        console.error('Erro ao rejeitar proposta:', error.response?.data || error);
        throw error;
    }
};
// Caso queira realmente atualizar supervisor via rota /propostas/:id/supervisor
export const atualizarSupervisor = async (idProposta, idSupervisor) => {
    return api.put(`/propostas/${idProposta}/supervisor`, { supervisorId: idSupervisor });
  };
  